import { createRef, MutableRefObject } from 'react';
import { NavigationContainerRef } from '@react-navigation/native';

type MutableRef<T extends unknown> = MutableRefObject<T | null>;

export const navigationRef = createRef<NavigationContainerRef>();
export const isReadyRef: MutableRef<boolean> = createRef();
export const routeNameRef: MutableRef<string | undefined> = createRef();
